export type Role = 'patient' | 'provider' | 'attorney'

export enum Roles {
  PATIENT = 'patient',
  PROVIDER = 'provider',
  ATTORNEY = 'attorney',
}
